import { adaptToDatabase } from '../../../utils/adaptToDatabase'
import apinode from '../../apinode'

class WmsEstEnderecoService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async insertUpdate(data) {
    const dataFormatted = data.map((product) =>
      adaptToDatabase(product, [
        'codendereco',
        'deposito',
        'rua',
        'predio',
        'nivel',
        'apto',
        'qt',
        'qtpendentrada',
        'qtpendsaida',
        'qtbloqueada',
        'quantidade',
      ]),
    )

    await apinode.patch(`/wmsEstEndereco/${this.idconta}`, dataFormatted)
  }
}

export default new WmsEstEnderecoService()
